import type { FC } from 'react';
import React from 'react';
import { Text } from '@oneaudi/unified-web-components';
import styled from 'styled-components';

interface FrostyBadgeProps {
  readonly text: string;
  readonly type?: 'default' | 'markAsNew';
}

export const FrostyBadge: FC<FrostyBadgeProps> = ({ text, type = 'default' }) => (
  <FrostyBadgeWrapper type={type} data-testid={`badge-${type}`}>
    <FrostyBadgeText
      variant={{
        order: '2',
        style: 'normal',
        type: 'copy',
      }}
    >
      {text}
    </FrostyBadgeText>
  </FrostyBadgeWrapper>
);

const FrostyBadgeWrapper = styled.div<{ type: 'default' | 'markAsNew' }>`
  padding: var(--spacing-relative-2xs) var(--spacing-relative-sm);
  background: ${({ theme, type }) =>
    type === 'markAsNew' ? theme.colors.badgeNewBgColor : theme.colors.badgeTypeBgColor};

  backdrop-filter: ${(props) => (props.type !== 'markAsNew' ? 'blur(20px)' : 'none')};
`;

const FrostyBadgeText = styled(Text)`
  color: ${({ theme }) => theme.colors.badgeTextColor} !important;
`;
